import type { RefObject } from 'react'
import { useRef } from 'react'

type UseFocus = () => [RefObject<HTMLButtonElement>, () => void]

export const useFocus: UseFocus = () => {
  const htmlElRef = useRef<HTMLButtonElement>(null)

  const setFocus = () => {
    htmlElRef.current?.focus()
  }

  return [htmlElRef, setFocus]
}
